import React from 'react';
import { Box, Button, Popover, Slider, Typography, TextField } from '@mui/material';
import { FiChevronDown, FiX } from 'react-icons/fi';

const MIN = 0;
const MAX = 5000;
const STEP = 50;

const PriceDropdown = ({ precoMin, precoMax, onChange }) => {
    const [anchorEl, setAnchorEl] = React.useState(null);
    const [localRange, setLocalRange] = React.useState([precoMin ?? MIN, precoMax ?? MAX]);

    React.useEffect(() => {
        setLocalRange([precoMin ?? MIN, precoMax ?? MAX]);
    }, [precoMin, precoMax]);

    const isActive =
        (precoMin !== null && precoMin !== undefined) || (precoMax !== null && precoMax !== undefined);

    const commit = (next) => {
        const [a, b] = next;
        onChange({
            precoMin: a === MIN ? null : a,
            precoMax: b === MAX ? null : b
        });
    };

    const handleSlider = (_, value) => setLocalRange(value);

    const handleInput = (index) => (e) => {
        const raw = e.target.value.replace(/\D/g, '');
        const value = raw === '' ? (index === 0 ? MIN : MAX) : Math.min(MAX, Math.max(MIN, Number(raw)));
        const next = [...localRange];
        next[index] = value;
        if (next[0] > next[1]) next[index] = next[1 - index];
        setLocalRange(next);
        commit(next);
    };

    const label = isActive
        ? `R$ ${precoMin ?? 0} - ${precoMax ?? '∞'}`
        : 'Faixa de preço';

    return (
        <>
            <Button
                onClick={(e) => setAnchorEl(e.currentTarget)}
                endIcon={<FiChevronDown size={14} />}
                sx={{
                    flexShrink: 0,
                    textTransform: 'none',
                    fontSize: 13,
                    fontWeight: 600,
                    height: 34,
                    px: 1.5,
                    borderRadius: 2,
                    border: '1px solid',
                    borderColor: isActive ? '#1a1a2e' : 'grey.300',
                    bgcolor: isActive ? '#1a1a2e' : '#fff',
                    color: isActive ? '#fff' : '#1a1a2e',
                    '&:hover': {
                        borderColor: '#1a1a2e',
                        bgcolor: isActive ? '#2a2a3e' : '#f0f1f5'
                    }
                }}
            >
                {label}
            </Button>

            <Popover
                open={Boolean(anchorEl)}
                anchorEl={anchorEl}
                onClose={() => setAnchorEl(null)}
                anchorOrigin={{ vertical: 'bottom', horizontal: 'left' }}
                transformOrigin={{ vertical: 'top', horizontal: 'left' }}
                PaperProps={{
                    sx: {
                        mt: 0.75,
                        width: 260,
                        borderRadius: 2,
                        border: '1px solid',
                        borderColor: 'grey.200',
                        boxShadow: '0 8px 24px rgba(0,0,0,0.12)'
                    }
                }}
            >
                <Box sx={{ p: 2 }}>
                    <Box sx={{ px: 1 }}>
                        <Slider
                            value={localRange}
                            onChange={handleSlider}
                            onChangeCommitted={(_, v) => commit(v)}
                            min={MIN}
                            max={MAX}
                            step={STEP}
                            size="small"
                            sx={{ color: '#1a1a2e' }}
                        />
                    </Box>
                    <Box sx={{ display: 'flex', gap: 1, mt: 1 }}>
                        <TextField
                            label="Mín"
                            size="small"
                            value={localRange[0]}
                            onChange={handleInput(0)}
                            InputProps={{ sx: { fontSize: 12 } }}
                            InputLabelProps={{ sx: { fontSize: 12 } }}
                            sx={{ flex: 1 }}
                        />
                        <TextField
                            label="Máx"
                            size="small"
                            value={localRange[1]}
                            onChange={handleInput(1)}
                            InputProps={{ sx: { fontSize: 12 } }}
                            InputLabelProps={{ sx: { fontSize: 12 } }}
                            sx={{ flex: 1 }}
                        />
                    </Box>
                    <Typography sx={{ fontSize: 10, color: 'text.secondary', mt: 1 }}>
                        Filtro aplicado no servidor
                    </Typography>
                    {isActive && (
                        <Button
                            fullWidth
                            size="small"
                            onClick={() => onChange({ precoMin: null, precoMax: null })}
                            startIcon={<FiX size={12} />}
                            sx={{
                                mt: 1,
                                textTransform: 'none',
                                fontSize: 11,
                                fontWeight: 600,
                                color: '#1a1a2e'
                            }}
                        >
                            Limpar faixa de preço
                        </Button>
                    )}
                </Box>
            </Popover>
        </>
    );
};

export default PriceDropdown;
